import { render, staticRenderFns } from "./MoveOutOfColumnButton.vue?vue&type=template&id=854ea6fe&scoped=true&"
import script from "./MoveOutOfColumnButton.vue?vue&type=script&lang=js&"
export * from "./MoveOutOfColumnButton.vue?vue&type=script&lang=js&"
import style0 from "./MoveOutOfColumnButton.vue?vue&type=style&index=0&id=854ea6fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854ea6fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
